<template>
  <div class="index-box">
    <div class="meetingDetail">
      <div class="domesticDiv" v-for="(item, index) in part" :key="index">
        <div class="FirstLevelTitle leftShift" v-if="item.list.length > 0">
          <div>{{ item.title }}</div>
          <div v-if="item.list.length == 4" @click="gotoWhole(item)">展开</div>
          <div v-if="item.list.length > 4" @click="gotoPutItAway(item)">
            收起
          </div>
        </div>

        <div class="domesticMeetingDiv clearfix">
          <div
            class="domesticMeeting"
            v-for="(item, index) in item.list"
            :key="index"
            @click="gotoMeetingDetail(item.id)"
          >
            <div class="domesticMeetingImgDiv">
              <img
                :src="item.img"
                alt="校友会图片"
                class="domesticMeetingImg"
              />
            </div>
            <div class="domesticMeetingName">{{ item.title }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // 国内1  院系2  国外3 其他4 辽宁5
      part: [
        {
          index: 0,
          list: [],
          title: "辽宁",
        },
        {
          index: 1,
          list: [],
          title: "国内",
        },
        {
          index: 2,
          list: [],
          title: "国外",
        },
        {
          index: 3,
          list: [],
          title: "院系",
        },
        {
          index: 4,
          list: [],
          title: "其他",
        },
      ],
    };
  },
  created() {
    this.getPart();
  },
  methods: {
    // 获取所有类别部分各地校友
    async getPart() {
      const result = await this.$http.get("/branch/getAllBranchListByType");
      const list = result.data;
      console.log("校友列表", list);

      // 辽宁
      if (list.liaoning.length > 4 && list.liaoning != "") {
        this.part[0].list = list.liaoning.slice(0, 4);
      } else {
        this.part[0].list = list.liaoning;
      }

      // 国内
      if (list.guonei.length > 4 && list.guonei != "") {
        this.part[1].list = list.guonei.slice(0, 4);
      } else {
        this.part[1].list = list.guonei;
      }

      // 国外
      if (list.guowai.length > 4 && list.guowai != "") {
        this.part[2].list = list.guowai.slice(0, 4);
      } else {
        this.part[2].list = list.guowai;
      }

      // 院系
      if (list.yuanxi.length > 4 && list.yuanxi != "") {
        this.part[3].list = list.yuanxi.slice(0, 4);
      } else {
        this.part[3].list = list.yuanxi;
      }

      // 其他
      if (list.other.length > 4 && list.other != "") {
        this.part[4].list = list.other.slice(0, 4);
      } else {
        this.part[4].list = list.other;
      }
    },

    // 展开
    async gotoWhole(item) {
      const result = await this.$http.get("/branch/getAllBranchListByType");
      const list = result.data;
      console.log("校友列表", list);

      if (item.index == 0) {
        // 辽宁
        this.part[0].list = list.liaoning;
        return;
      }

      if (item.index == 1) {
        // 国内
        this.part[1].list = list.guonei;
        return;
      }

      if (item.index == 2) {
        // 国外
        this.part[2].list = list.guowai;
        return;
      }
      if (item.index == 3) {
        // 院系
        this.part[3].list = list.yuanxi;
        return;
      }
      if (item.index == 4) {
        // 其他
        this.part[4].list = list.other;
        return;
      }
      console.log("各地校友列表", this.part);
    },

    // 收起
    async gotoPutItAway(item) {
      const result = await this.$http.get("/branch/getAllBranchListByType");
      const list = result.data;
      console.log("校友列表", list);

      if (item.index == 0) {
        // 辽宁
        this.part[0].list = list.liaoning.slice(0, 4);
        return;
      }

      if (item.index == 1) {
        // 国内
        this.part[1].list = list.guonei.slice(0, 4);
        return;
      }

      if (item.index == 2) {
        // 国外
        this.part[2].list = list.guowai.slice(0, 4);
        return;
      }
      if (item.index == 3) {
        // 院系
        this.part[3].list = list.yuanxi.slice(0, 4);
        return;
      }
      if (item.index == 4) {
        // 其他
        this.part[4].list = list.other.slice(0, 4);
        return;
      }
      console.log("各地校友列表", this.part);
    },

    gotoMeetingDetail(id) {
      return this.$router.push({
        path: "/alumniDetail",
        query: {
          id: id,
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.index-box {
  position: relative;
  object-fit: cover;
}
.clearfix:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.clearfix {
  *zoom: 1;
}
.nav {
  position: fixed;
  top: 0px;
  background-color: #e7e7e7;
  width: 100%;
}
.navDiv {
  position: relative;
  left: 5%;
  width: 90%;
}
.detailsNav {
  float: left;
  width: 25%;
  padding: 10px 0px 10px 0px;
  text-align: center;
  color: gray;
}
a:link {
  color: gray;
  text-decoration: none;
}
a:visited {
  color: gray;
  text-decoration: none;
}
a:hover {
  color: gray;
  text-decoration: none;
}
.titleDiv {
  margin-left: 5%;
  height: 7vw;
  display: flex;
  width: 90%;
  margin-top: 20px;
  .titleIcon {
    width: 4px;
    height: 6vw;
    background-color: #00706e;
    border-radius: 15px;
  }
  .titleWord {
    padding-left: 10px;
    font-size: 1.3em;
    font-weight: bold;
    color: #333333;
  }
}
.meetingDetail {
  position: relative;
  margin-top: 10px;
  // height:100vh;
  // height: calc(100vh - 20px);
  overflow-y: scroll;
  .domesticDiv,
  .abroadDiv,
  .collegesDiv,
  .otherDiv {
    position: relative;
    .domesticMeetingDiv,
    .abroadMeetingDiv,
    .collegesMeetingDiv,
    .otherMeetingDiv {
      position: relative;
      left: 5%;
      margin-top: 10px;
      width: 90%;
      .domesticMeeting,
      .abroadMeeting,
      .collegesMeeting,
      .otherMeeting {
        float: left;
        width: 47%;
        margin: 0 1.5%;
        .domesticMeetingImgDiv,
        .abroadMeetingImgDiv,
        .collegesMeetingImgDiv,
        .otherMeetingImgDiv {
          width: 100%;
          height: 18vh;
          .domesticMeetingImg,
          .abroadMeetingImg,
          .collegesMeetingImg,
          .otherMeetingImg {
            width: 100%;
            height: 100%;
            border-radius: 15px;
            object-fit: cover;
            // object-position: center;
          }
        }
        .domesticMeetingName,
        .abroadMeetingName,
        .collegesMeetingName,
        .otherMeetingName {
          text-align: center;
          margin: 5px 0 10px 0;
          font-size: 1.13rem;
          width: 100%;
          font-weight: bold;
          overflow: hidden;
          color: #333333;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          white-space: pre-line;
        }
      }
    }
  }
}
.meetingDetail::-webkit-scrollbar {
  display: none;
}
.hrDiv {
  width: 95%;
  height: 3px;
  margin-left: 2.5%;
  background: #e7e7e7;
}

.clubDisplayDiv {
  width: 90%;
  margin: 0 5%;
  .clubDisplay {
    width: 100%;

    .imgAndName {
      display: flex;

      .clubImgDiv {
        width: 15vw;
        height: 15vw;
        border: 1px solid #bfbfbf;
        border-radius: 15px;

        .clubImg {
          margin: 10%;
          width: 80%;
          height: 80%;
        }
      }

      .clubName {
        margin: auto 20px;
        font-size: 1.2rem;
      }
    }

    .driver {
      margin: 15px 0;
      width: 100%;
      height: 1px;
      background: #dedede;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/alumniMeeting/AlumniMeeting.vue